$(document).ready(function () {
	$('.to-product-characteristics').click(function () {
		let $btn = $("#characteristics-tab")
		$btn.click();

		$([document.documentElement, document.body]).animate({
			scrollTop: $btn.offset().top
		}, 500);
	});

	$(document).on('change', '.product-price .nds-toggle [type=checkbox]', function () {
		let $container = $(this).closest('.product-price');
		let $price = $container.find('.new-price');
		let $priceValue = $price.find('.value');
		let $priceOriginal = $container.find('del');

		let checked = Number($(this).prop('checked'));

		let d = {
			0: {price: $container.data('price')},
			1: {price: $container.data('price_nds')},
		}[checked];

		$priceValue.text(output_money(d.price));

		if ($priceOriginal.length) {
			let d = {
				0: {price: $container.data('price_original')},
				1: {price: $container.data('price_original_nds')},
			}[checked];

			$priceOriginal.text(output_money(d.price));
		}
	});
});
